module.exports = __webpack_public_path__ + "img/immersive-design.a9d29039.jpg";